import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'

const PanelInput = ({ value, error, success, fontSize = 'xxx-large' }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      {error ? (
        <TextField
          value="Error registrando fichaje."
          variant="standard"
          fullWidth
          disabled
          slotProps={{
            input: {
              sx: {
                fontSize: fontSize,
                textAlign: 'center !important',
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: 'var(--mui-palette-error-main) !important',
                color: 'var(--mui-palette-error-dark) !important',
              },
              inputProps: { style: { textAlign: 'center', fontSize: fontSize } },
              style: { textAlign: 'center !important' },
            },
          }}
        />
      ) : success ? (
        <TextField
          value="Fichaje registrado con éxito."
          variant="standard"
          fullWidth
          disabled
          slotProps={{
            input: {
              sx: {
                fontSize: fontSize,
                textAlign: 'center !important',
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: 'var(--mui-palette-success-main) !important',
                color: 'var(--mui-palette-success-dark) !important',
              },
              inputProps: { style: { textAlign: 'center', fontSize: fontSize } },
              style: { textAlign: 'center !important' },
            },
          }}
        />
      ) : (
        <TextField
          value={value}
          variant="standard"
          placeholder="Introduce tu código o utiliza el escáner de QR"
          fullWidth
          disabled
          slotProps={{
            input: {
              sx: {
                fontSize: fontSize,
                textAlign: 'center !important',
                display: 'flex',
                justifyContent: 'center',
              },
              inputProps: { style: { textAlign: 'center', fontSize: fontSize } },
              style: { textAlign: 'center !important' },
            },
          }}
        />
      )}
    </Box>
  )
}

export default PanelInput
